import { render, staticRenderFns } from "./ModalSignPayslip.vue?vue&type=template&id=45ec330c&scoped=true"
import script from "./ModalSignPayslip.vue?vue&type=script&lang=js"
export * from "./ModalSignPayslip.vue?vue&type=script&lang=js"
import style0 from "./ModalSignPayslip.vue?vue&type=style&index=0&id=45ec330c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ec330c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45ec330c')) {
      api.createRecord('45ec330c', component.options)
    } else {
      api.reload('45ec330c', component.options)
    }
    module.hot.accept("./ModalSignPayslip.vue?vue&type=template&id=45ec330c&scoped=true", function () {
      api.rerender('45ec330c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MyPayslips/ModalSignPayslip.vue"
export default component.exports